var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf-gen',{ref:"pdf-gen",attrs:{"header-data":_vm.headerPDF,"images":_vm.imagesPDF,"content-data":Array(_vm.proposePDF, _vm.mainBlockPDF, _vm.tableBlockPDF, _vm.infoBlockPDF),"page-margins":[0, 105, 0, 30],"name":_vm.fileName + '.pdf'}})
}
var staticRenderFns = []

export { render, staticRenderFns }